// extracted by mini-css-extract-plugin
export default {"privacy-policy-footer":"style_privacy-policy-footer__GJnWt"};